import axios from 'axios';
import { LocalStore } from 'constants/localstore';

export const shareFile = async (file: File, metadata: string, cb: (progress: number) => void) => {
  const formData = new FormData();
  formData.append('media', new Blob([metadata], { type: 'application/json' }));
  formData.append('video', file);
  try {
    await axios.post('https://www.googleapis.com/upload/youtube/v3/videos?part=snippet,status', formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(LocalStore.youtubeOAuth)}`,
        'Content-Type': 'multipart/related',
      },
      onUploadProgress: (e) => cb(e.progress ?? 0),
    });
  } catch (err) {
    throw '401';
  }
};
